import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useTop10 } from './hooks/useTop10';

export const Top10 = () => {
    const { subtitles, values } = useTop10();

    return (
        <SimpleBars
            title={`Total de Procedimentos (Top 10)`}
            subtitles={subtitles}
            values={values}
            horizontal
            height={400}
        />
    );
};
